import { OrgRoleIds } from "models/Role.model";
import type { ManagedSecretSummary } from "server/devplane/managedSecrets/api";
import { isOrgAdminOrMaintainerRole } from "utils/roleUtils";

export const getLaunchableManagedSecretsAvailableToUser = (
  secrets: ManagedSecretSummary[],
  userId: string | undefined,
  orgRole: OrgRoleIds | undefined,
): ManagedSecretSummary[] => {
  if (isOrgAdminOrMaintainerRole(orgRole)) {
    return secrets;
  }

  if (!userId) {
    return [];
  }

  return secrets.filter((secret) =>
    secret.userAccesses.some((access) => access.userId === userId),
  );
};
